

























































































import { portalApi } from '../../../api/api';
import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerEcology from "./../../common/banner/bannerEcology.vue";

@Component({
    components:{
        BannerEcology
    }
})
export default class courseIndex extends Vue {
    private isPage: Boolean = false;
    public title: String = '';
    public docUrl: String = '';
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_ecology.png'),
        title: '培训课程',
    };
    public loading: Boolean = false;
    public list:any = [];

    public keyword: String = "";
    public role: Number = -1;
    public level: Number = -1;
    public type: Number = -1;

    roleClick(role:Number){
        this.pageNum = 1;
        this.role = role;
        this.getList();
    }
    levelClick(level:Number) {
        this.pageNum = 1;
        this.level = level;
        this.getList();
    }
    typeClick(type:Number) {
        this.pageNum = 1;
        this.type = type;
        this.getList();
    }
    //分页跳转
    public pageNum:Number = 1;
    public pageSize:Number = 12;
    public total:Number = 0;
    public listArr: any = [];
    changePageNum (val:Number) {
      this.listArr = [];
      this.pageNum = val;
      this.getList();
      window.scrollTo(0, 0);//页面到顶部;
    }
    searchQuery(): void{
        this.getList();
    }
    getList(): void{
        this.loading = true;
        let data = {
            name: this.keyword,
            level: this.level == -1 ? null : this.level,
            type: this.type == -1 ? null : this.type,
            stuRole: this.role == -1 ? null : this.role,
            limit: this.pageSize,
            page: this.pageNum
        }
        portalApi.coursePageList(data).then(res => {
            this.list = [];
            this.total = 0;
            if (res){
                this.list = res.data.list;
                this.total = res.data.total;
            }
            this.loading = false;
        })
    }
    details(obj: any){
        this.title = obj.typeName +' - '+ obj.name;
        this.isPage = true;
        this.docUrl = obj.url;
    }
    returnPage() {
        this.isPage = false;
        this.title = '';
    }

    created(){
       this.getList(); 
    }
}

